import { useEffect, useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { RETURN_POLICY_VALIDATION } from 'services/validation/returnPolicyValidation'
import { ReturnPolicy } from 'components/more-info-page/return-policy/ReturnPolicy'
import { useFetch } from 'services/useFetch'
import { API_RETURN_POLICY } from 'services/apiReturnPolicy'
import { Alert } from 'avo-ui'
import { convertErrorMessage } from 'utils/utils'

const INITIAL_STATE = {
    title: null,
    description: null,
}

const FIELD_NAME_DETAIL = {
    title: 'Title',
    description: 'Description',
}

export const ReturnPolicyContainer = () => {
    const [returnPolicyDetail, setReturnPolicyDetail] = useState(INITIAL_STATE)
    const { fetching: getReturnPolicyDetail, isLoading } = useFetch(API_RETURN_POLICY.DETAIL)
    const { fetching: updateReturnPolicy, isLoading: isUpdating } = useFetch(API_RETURN_POLICY.UPDATE)
    const [errorMessage, setErrorMessage] = useState({})
    const { validateForm, errorForm } = useValidation({
        form: returnPolicyDetail,
        schema: RETURN_POLICY_VALIDATION,
    })

    const onChangeForm = (e) => {
        const { name, value } = e
        setReturnPolicyDetail({ ...returnPolicyDetail, [name]: value })
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            updateReturnPolicy(returnPolicyDetail)
                .then(() => {
                    return Alert({
                        icon: 'success',
                        title: 'Success',
                        message: 'Return Policy Updated !',
                    })
                })
                .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
        })
    }

    useEffect(() => {
        getReturnPolicyDetail().then((response) => setReturnPolicyDetail({ ...response?.data }))
    }, [])

    const props = {
        returnPolicyDetail,
        errorForm: { ...errorForm, ...errorMessage },
        onChangeForm,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <ReturnPolicy {...props} />
}
